import { Nav, Tab } from "react-bootstrap";
import { IIncidentUpdateRequestDetails } from "../../../api/Incident/IIncidentUpdateRequestDetails";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  incidentUpdateRequestDetails: IIncidentUpdateRequestDetails;
  licenceProfile: ILicenceProfile;
}

interface RelatedComplianceProps {
  incidentUpdateRequestDetails: IIncidentUpdateRequestDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  incidentUpdateRequestDetails,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={
              incidentUpdateRequestDetails.incidentupdaterequestid
            }
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  incidentUpdateRequestDetails,
  licenceProfile,
}: RelatedComplianceProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      incidentUpdateRequestDetails={incidentUpdateRequestDetails}
      licenceProfile={licenceProfile}
    />
  );
  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
